import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import {
    formatAdjustmentPayload,
    formatAdjustmentResponse,
    validateAdjustmentPayload
} from "../../utils/adjustment-utils";
import { hasValidationErrors } from "../../../utils/validation-utils";

export function useAdjustmentUpdate() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});

    const validateAdjustment = values => {
        const errors = validateAdjustmentPayload(values);

        setValidationErrors(errors);

        return errors;
    };

    async function updateAdjustment(adjustmentId, payloadData) {
        const errors = validateAdjustmentPayload(payloadData);

        if (hasValidationErrors(errors)) {
            setValidationErrors(errors);
            setError(null);

            return {
                ok: false,
                reason: "validation",
                validationErrors: errors
            };
        }

        try {
            setLoading(true);
            setError(null);
            setValidationErrors({});

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const body = formatAdjustmentPayload(payloadData);

            const requestOptions = {
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
					"access_token": accessToken,
					"client_id": clientId
				},
				body: JSON.stringify(body)
			};

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
					`pacto-rebates-admin/v1/reajustes/${encodeURIComponent(adjustmentId)}`,
				requestOptions
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível editar o reajuste."
                );
            }

            const data = await response.json();

            const adjustmentData = Array.isArray(data.resultado)
                ? data.resultado[0]
                : data.resultado || data;

            const formattedAdjustment = formatAdjustmentResponse(adjustmentData);

            return {
                ok: true,
                adjustment: formattedAdjustment
            };
        } catch (requestError) {
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        error,
        validationErrors,
        validateAdjustment,
        updateAdjustment
    };
}